/* tslint:disable */

declare var Object: any;
export interface ApplicantResumeParseInterface {
  "uuid"?: string;
  "candidateEmailId"?: string;
  "name"?: string;
  "email"?: string;
  "phone"?: string;
  "fileUrl"?: string;
  "previewContainer"?: Array<any>;
  "isDeleted"?: boolean;
  "id"?: any;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class ApplicantResumeParse implements ApplicantResumeParseInterface {
  "uuid": string;
  "candidateEmailId": string;
  "name": string;
  "email": string;
  "phone": string;
  "fileUrl": string;
  "previewContainer": Array<any>;
  "isDeleted": boolean;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ApplicantResumeParseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ApplicantResumeParse`.
   */
  public static getModelName() {
    return "ApplicantResumeParse";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ApplicantResumeParse for dynamic purposes.
  **/
  public static factory(data: ApplicantResumeParseInterface): ApplicantResumeParse{
    return new ApplicantResumeParse(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ApplicantResumeParse',
      plural: 'ApplicantResumeParses',
      path: 'ApplicantResumeParses',
      idName: 'id',
      properties: {
        "uuid": {
          name: 'uuid',
          type: 'string'
        },
        "candidateEmailId": {
          name: 'candidateEmailId',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "fileUrl": {
          name: 'fileUrl',
          type: 'string'
        },
        "previewContainer": {
          name: 'previewContainer',
          type: 'Array&lt;any&gt;'
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
